import { useEffect, useState } from 'react';
import { MenuItem } from '@mui/material';
import { useAutocomplete } from '@refinedev/mui';

import { CheckboxInput } from '@attackiq/components';

import { AutocompleteInput, TextFieldInput } from '../../../components';

export const NameInput = ({ required = true }) => {
  return (
    <TextFieldInput
      name="name"
      label="Name"
      rules={required ? { required: 'Package name is required' } : {}}
      fullWidth
      margin="normal"
    />
  );
};

export const DescriptionInput = () => {
  return <TextFieldInput name="description" label="Description" fullWidth margin="normal" />;
};

export const PackageTypeInput = ({ isLoading, val = '' }) => {
  const [packageTypeValue, setPackageTypeValue] = useState('');

  const { autocompleteProps } = useAutocomplete({
    resource: 'flex_package_types',
    pagination: {
      pageSize: 10000
    },
    debounce: 400,
    onSearch: searchText => [
      {
        field: 'name__icontains',
        operator: 'contains',
        value: searchText
      }
    ]
  });

  const { options } = autocompleteProps;

  useEffect(() => {
    if (val && !isLoading) {
      const option = options.find(element => element.id === val);
      if (option) {
        setPackageTypeValue(option);
      }
    }
  }, [isLoading, options, val]);

  return (
    <AutocompleteInput
      {...autocompleteProps}
      sx={{ mt: 0.5 }}
      name="package_type"
      rules={{ required: 'Package Type is required' }}
      defaultValue={null}
      getOptionLabel={option => option.name || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={packageTypeValue}
      onChange={(event, newValue) => {
        setPackageTypeValue(newValue);
      }}
      TextFieldProps={{
        label: 'Package Type',
        required: true
      }}
    />
  );
};

export const ProjectTemplateInput = () => {
  const { autocompleteProps } = useAutocomplete({
    resource: 'assessment_templates',
    pagination: {
      pageSize: 50
    },
    debounce: 400,
    onSearch: searchText => [
      {
        field: 'template_name__icontains',
        operator: 'contains',
        value: searchText
      }
    ]
  });

  return (
    <AutocompleteInput
      {...autocompleteProps}
      sx={{ mt: 0.5 }}
      name="project_template"
      rules={{ required: 'Project Template is required' }}
      defaultValue={null}
      getOptionLabel={option => option.template_name || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      TextFieldProps={{
        label: 'Project Template',
        required: true
      }}
    />
  );
};

export const CreditsInput = () => {
  return <TextFieldInput name="credits" label="Credits" fullWidth margin="normal" />;
};

export const PurposeInput = () => {
  return <TextFieldInput name="purpose" label="Purpose" fullWidth margin="normal" />;
};

export const VersionInput = () => {
  return <TextFieldInput name="version" label="Version" fullWidth margin="normal" />;
};

export const FeaturedCheckbox = ({ defaultValue = false }) => {
  return <CheckboxInput label="Featured" name="featured" defaultValue={defaultValue} />;
};

const OS_OPTIONS = [
  { v: 'windows', label: 'Windows' },
  { v: 'linux', label: 'Linux' },
  { v: 'os x', label: 'OSX' }
];

const ARCH_OPTIONS = [{ v: 'amd64', label: 'AMD 64' }];

export const PackageOSSelector = ({ defaultValue = 'windows' }) => {
  return (
    <TextFieldInput name="os" label="Package OS" select fullWidth defaultValue={defaultValue} margin="normal">
      {OS_OPTIONS.map(({ v, label }) => (
        <MenuItem key={v} value={v}>
          {label}
        </MenuItem>
      ))}
    </TextFieldInput>
  );
};

export const PackageArchSelector = ({ defaultValue = 'amd64' }) => {
  return (
    <TextFieldInput
      name="arch"
      label="Package Architecture"
      select
      fullWidth
      defaultValue={defaultValue}
      margin="normal"
    >
      {ARCH_OPTIONS.map(({ v, label }) => (
        <MenuItem key={v} value={v}>
          {label}
        </MenuItem>
      ))}
    </TextFieldInput>
  );
};
